import Home from '@/views/Home/Home.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { Auth } from './utility'
import http from '@/http'

const routes = [
    {
        path: '/',
        component: Home,
        name: 'home',
        meta: {
            title: 'Home',
        },
    },
    {
        path: '/login',
        component: () => import('./views/Login/Login.vue'),
        name: 'login',
        meta: {
            title: 'Login',
        },
    },
    {
        path: '/reset-password/:token',
        component: () => import('./views/ResetPassword/ResetPassword.vue'),
        name: 'reset-password',
        meta: {
            title: 'Alteração de Senha',
        },
    },
    {
        path: '/users',
        component: () => import('@/views/Users/Users.vue'),
        name: 'usuarios',
        meta: {
            title: 'Usuários',
        },
    },
    {
        path: '/clients',
        component: () => import('@/views/Clients/Clients.vue'),
        name: 'clientes',
        meta: {
            title: 'Clientes',
        },
    },
    {
        path: '/checker-simple',
        component: () => import('@/views/SimpleChecker/SimpleChecker.vue'),
        name: 'consulta-ao-simples',
        meta: {
            title: 'Consulta ao Simples',
        },
        children: [
            {
                path: 'batches',
                component: () => import('@/views/SimpleChecker/Batches.vue'),
                meta: {
                    title: 'Lotes de Consulta',
                },
            },
            {
                path: 'new-batch',
                component: () => import('@/views/SimpleChecker/NewBatch.vue'),
                meta: {
                    title: 'Nova Busca',
                },
            },
            {
                path: 'export',
                component: () => import('@/views/SimpleChecker/Export.vue'),
                meta: {
                    title: 'Exportar',
                },
            },
        ],
    },
    {
        path: '/validation-xml',
        component: () => import('@/views/Verify/VerificationList.vue'),
        name: 'validation-xml',
        meta: {
            title: 'Validação de XML',
        },
    },
    {
        path: '/database-update',
        component: () => import('@/views/DatabaseUpdate/DatabaseUpdate.vue'),
        name: 'atualizacao-de-base',
        meta: {
            title: 'Atualização de Base',
        },
        children: [
            {
                path: 'classify-items',
                component: () =>
                    import('@/views/DatabaseUpdate/ClassifyItems.vue'),
                meta: {
                    title: 'Itens a Classificar',
                },
            },
            {
                path: 'update-items',
                component: () =>
                    import('@/views/DatabaseUpdate/UpdateItems.vue'),
                meta: {
                    title: 'Atualizar Itens',
                },
            },
            {
                path: 'bulk-update',
                component: () =>
                    import('@/views/DatabaseUpdate/BulkUpdate.vue'),
                meta: {
                    title: 'Atualização em Massa',
                },
            },
            {
                path: 'ncm-movement-items',
                component: () =>
                    import('@/views/DatabaseUpdate/NcmMovementItems.vue'),
                meta: {
                    title: 'Movimentação NCM',
                },
            },
        ],
    },
    {
        path: '/xml-nfe',
        component: () => import('./views/XmlNfe/XmlNfe.vue'),
        name: 'xml-nfe',
        meta: {
            title: 'XML NFe',
        },
        children: [
            {
                path: 'admin',
                component: () =>
                    import('@/views/XmlNfe/AdministrativePanel.vue'),
                meta: {
                    title: 'Painel Administrativo',
                },
            },
            {
                path: 'find-xml',
                component: () => import('@/views/XmlNfe/SearchXml.vue'),
                meta: {
                    title: 'Buscar XML',
                },
            },
            {
                path: 'download-xml',
                component: () => import('@/views/XmlNfe/ListBatch.vue'),
                meta: {
                    title: 'Exportar XMLs',
                },
            },
            {
                path: 'financial-report',
                component: () => import('@/views/XmlNfe/FinancialReport.vue'),
                meta: {
                    title: 'Relatório Financeiro',
                },
            },
        ],
    },
    {
        path: '/icms-fine-diagnosis',
        component: () =>
            import('./views/IcmsFineDiagnosis/IcmsFineDiagnosis.vue'),
        name: 'icms-fine-diagnosis',
        meta: {
            title: 'Diagnóstico de ICMS',
        },
        children: [
            {
                path: 'import-sped',
                component: () =>
                    import('@/views/IcmsFineDiagnosis/ImportSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'generate-diagnosis',
                component: () =>
                    import('@/views/IcmsFineDiagnosis/GenerateDiagnosis.vue'),
                meta: {
                    title: 'Diagnóstico',
                },
            },
            {
                path: 'list-diagnosis',
                component: () =>
                    import('@/views/IcmsFineDiagnosis/ListDiagnosis.vue'),
                meta: {
                    title: 'Exportar',
                },
            },
        ],
    },
    {
        path: '/funds',
        component: () => import('@/views/Funds/Funds.vue'),
        name: 'verbas',
        meta: {
            title: 'Verbas',
        },
        children: [
            {
                path: 'import-manad',
                component: () => import('@/views/Funds/ImportManad.vue'),
                meta: {
                    title: 'Importar MANAD',
                },
            },
            {
                path: 'classify-rubrics',
                component: () => import('@/views/Funds/ClassifierRubrica.vue'),
                meta: {
                    title: 'Classificar Rubricas',
                },
            },
            {
                path: 'generate-calculations',
                component: () => import('@/views/Funds/GenerateCalculus.vue'),
                meta: {
                    title: 'Gerar Calculos',
                },
            },
            {
                path: 'export-rubrics',
                component: () => import('@/views/Funds/ClassifierRubrica.vue'),
                meta: {
                    title: 'Exportar Rubricas',
                },
            },
            {
                path: 'list-calculations',
                component: () => import('@/views/Funds/ListCalculusFunds.vue'),
                meta: {
                    title: 'Exportar Calculos',
                },
            },
        ],
    },
    {
        path: '/account',
        component: () => import('@/views/Home/Account.vue'),
        name: 'conta',
        meta: {
            title: 'Perfil',
        },
    },
    {
        path: '/contact-us',
        component: () => import('@/views/ContactUs/ContactUs.vue'),
        name: 'fale-conosco',
        meta: {
            title: 'Fale Conosco',
        },
    },
    {
        path: '/subsidy',
        component: () => import('@/views/Subsidy/Subsidy.vue'),
        name: 'subvencao',
        meta: {
            title: 'Subvenção',
        },
        children: [
            {
                path: 'import-sped',
                component: () => import('@/views/Subsidy/ImportSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'calculate-simplified',
                component: () => import('@/views/Subsidy/GenerateCalculus.vue'),
                meta: {
                    title: 'Calcular Simplificado',
                },
            },
            {
                path: 'generate-items-data',
                component: () => import('@/views/Subsidy/GenerateAliquots.vue'),
                meta: {
                    title: 'Gerar Itens e Dados',
                },
            },
            {
                path: 'classify-items',
                component: () =>
                    import('@/views/Subsidy/ClassifierAliquots.vue'),
                meta: {
                    title: 'Classificar itens',
                },
            },
            {
                path: 'generate-calculations',
                component: () => import('@/views/Subsidy/GenerateCalculus.vue'),
                meta: {
                    title: 'Calcular Completo',
                },
            },
            {
                path: 'data-validation-list',
                component: () => import('@/views/Subsidy/ListAliquots.vue'),
                meta: {
                    title: 'Validação de dados',
                },
            },
            {
                path: 'calculations-list',
                component: () =>
                    import('@/views/Subsidy/ListCalculusSubsidy.vue'),
                name: 'subvencao',
                meta: {
                    title: 'Exportar calculos de subvenção',
                },
            },
        ],
    },
    {
        path: '/simple',
        component: () => import('@/views/Simple/Simple.vue'),
        name: 'simples-nacional',
        meta: {
            title: 'Simples Nacional',
        },
        children: [
            {
                path: 'import-sped',
                component: () => import('@/views/Simple/ImportSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'analyze-suppliers',
                component: () => import('@/views/Simple/SupplierAnalysis.vue'),
                meta: {
                    title: 'Analisar fornecedores',
                },
            },
            {
                path: 'classify-products',
                component: () => import('@/views/Simple/CstClassifier.vue'),
                meta: {
                    title: 'Classificar produtos',
                },
            },
            {
                path: 'generate-calculations',
                component: () => import('@/views/Simple/GenerateCalculus.vue'),
                meta: {
                    title: 'Gerar cálculos',
                },
            },
            {
                path: 'export-supplier-analysis-list',
                component: () => import('@/views/Simple/ListSuppliers.vue'),
                meta: {
                    title: 'Análise de fornecedores',
                },
            },
            {
                path: 'export-calculations-list',
                component: () => import('@/views/Simple/ListCalculus.vue'),
                meta: {
                    title: 'Lista de cálculos',
                },
            },
        ],
    },
    {
        path: '/food-basket',
        component: () => import('@/views/FoodBasket/FoodBasket.vue'),
        name: 'food-basket',
        meta: {
            title: 'Transferência de Itens Isentos',
        },
        children: [
            {
                path: 'import-sped',
                component: () => import('@/views/FoodBasket/ImportSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'extract-items',
                component: () => import('@/views/FoodBasket/ExtractItems.vue'),
                meta: {
                    title: 'Extrair itens',
                },
            },
            {
                path: 'classify-products',
                component: () =>
                    import('@/views/FoodBasket/ClassifyProducts.vue'),
                meta: {
                    title: 'Classificar produtos',
                },
            },
            {
                path: 'extract-entries',
                component: () =>
                    import('@/views/FoodBasket/GenerateCalculus.vue'),
                meta: {
                    title: 'Extrair Entradas',
                },
            },
            {
                path: 'generate-apurations',
                component: () =>
                    import('@/views/FoodBasket/FinishCalculus.vue'),
                meta: {
                    title: 'Gerar Apuração',
                },
            },
            {
                path: 'export-calculations',
                component: () => import('@/views/FoodBasket/ListCalculus.vue'),
                meta: {
                    title: 'Exportar cálculos',
                },
            },
        ],
    },
    {
        path: '/help/clients',
        component: () => import('@/views/Help/HelpClients.vue'),
        name: 'ajuda-clientes',
        meta: {
            title: 'Ajuda - Clientes',
        },
    },
    {
        path: '/help/xml-nfe',
        component: () => import('@/views/Help/HelpXmlNfe.vue'),
        name: 'ajuda-xml-nfe',
        meta: {
            title: 'Ajuda - XML NFe',
        },
    },
    {
        path: '/help/database-update',
        component: () => import('@/views/Help/HelpDatabaseUpdate.vue'),
        name: 'ajuda-atualizacao-de-base',
        meta: {
            title: 'Ajuda - Atualização de base',
        },
    },
    {
        path: '/help/subsidy',
        component: () => import('@/views/Help/HelpSubsidy.vue'),
        name: 'ajuda-subvencao',
        meta: {
            title: 'Ajuda - Subvenção',
        },
    },
    {
        path: '/help/validation-xml',
        component: () => import('@/views/Help/HelpValidation.vue'),
        name: 'ajuda-validacao-xml',
        meta: {
            title: 'Ajuda - Validation',
        },
    },
    {
        path: '/help/funds',
        component: () => import('@/views/Help/HelpFunds.vue'),
        name: 'ajuda-verbas',
        meta: {
            title: 'Ajuda - Verbas',
        },
    },
    {
        path: '/help/credit-pis-cofins',
        component: () => import('@/views/Help/HelpCreditPisCofins.vue'),
        name: 'ajuda-credito-pis-cofins',
        meta: {
            title: 'Ajuda - Pis/Cofins s/ Icms ST',
        },
    },
    {
        path: '/help/simple',
        component: () => import('@/views/Help/HelpSimple.vue'),
        name: 'ajuda-simples',
        meta: {
            title: 'Ajuda - Simples Nacional',
        },
    },
    {
        path: '/help/icms-fine-diagnosis',
        component: () => import('@/views/Help/HelpIcmsFineDiagnosis.vue'),
        name: 'ajuda-autuacoes-icms',
        meta: {
            title: 'Ajuda - Diagnóstico de ICMS',
        },
    },
    {
        path: '/help/checker-simple',
        component: () => import('@/views/Help/HelpSimpleChecker.vue'),
        name: 'ajuda-consulta-ao-simples',
        meta: {
            title: 'Ajuda - Consulta ao Simples',
        },
    },
    {
        path: '/help/food-basket',
        component: () => import('@/views/Help/HelpFoodBasket.vue'),
        name: 'ajuda-cesta-basica',
        meta: {
            title: 'Ajuda - Transferência de Itens Isentos',
        },
    },
    {
        path: '/help/icms-exclusion',
        component: () => import('@/views/Help/HelpIcmsExclusion.vue'),
        name: 'ajuda-exclusao-icms-st',
        meta: {
            title: 'Ajuda - Exclusão de ICMS ST',
        },
    },
    {
        path: '/help/icms-exclusion/demos',
        component: () => import('@/views/Help/HelpIcmsExclusionDemos.vue'),
        name: 'ajuda-exclusao-icms-st-demonstracoes',
        meta: {
            title: 'Ajuda - Exclusão de ICMS ST - Demonstrações',
        },
    },
    {
        path: '/help/forms',
        component: () => import('@/views/Help/HelpForms.vue'),
        name: 'ajuda-formularios',
        meta: {
            title: 'Ajuda - Formulários',
        },
    },
    {
        path: '/help/reforma-tributaria',
        component: () => import('@/views/Help/HelpReformaTributaria.vue'),
        name: 'ajuda-reforma-tributaria',
        meta: {
            title: 'Ajuda - Diagnóstico da Reforma Tributária',
        },
    },
    {
        path: '/news/create',
        component: () => import('@/views/News/NewsPageCreate.vue'),
        name: 'newatualizacoes',
        meta: {
            title: 'Atualizações',
        },
    },
    {
        path: '/news/edit',
        component: () => import('@/views/News/NewsPageEdit.vue'),
        name: 'atualizacoes',
        meta: {
            title: 'Atualizações',
        },
    },
    {
        path: '/credit-pis-cofins',
        component: () => import('@/views/CreditPisCofins/Home.vue'),
        name: 'credito-pis-cofins',
        meta: {
            title: 'Pis/Cofins s/ Icms ST',
        },
        children: [
            {
                path: 'import-sped',
                component: () =>
                    import('@/views/CreditPisCofins/ImportSPED.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'import-xml',
                component: () =>
                    import('@/views/CreditPisCofins/ImportXML.vue'),
                meta: {
                    title: 'Importar XML',
                },
            },
            {
                path: 'xml-list',
                component: () =>
                    import('@/views/CreditPisCofins/GenerateXMLList.vue'),
                meta: {
                    title: 'Gerar Lista de XML',
                },
            },
            {
                path: 'calculate',
                component: () =>
                    import('@/views/CreditPisCofins/GenerateCalc.vue'),
                meta: {
                    title: 'Gerar cálculos',
                },
            },
            {
                path: 'export-xml-list',
                component: () =>
                    import('@/views/CreditPisCofins/ListImportsXMLList.vue'),
                meta: {
                    title: 'Exportar Lista de XML',
                },
            },
            {
                path: 'export-calculations',
                component: () => import('@/views/CreditPisCofins/ListCalc.vue'),
                meta: {
                    title: 'Exportar cálculos',
                },
            },
        ],
    },
    {
        path: '/forms',
        component: () => import('@/views/NewForms/NewForms.vue'),
        name: 'forms',
        meta: {
            title: 'Solicitar Cálculo',
        },
        children: [
            {
                path: 'forms-history',
                component: () => import('@/views/NewForms/FormHistory.vue'),
                meta: {
                    title: 'Histórico de Solicitações',
                },
            },
        ],
    },
    {
        path: '/certificates/upload/:token',
        type: 'public',
        component: () =>
            import('@/views/XmlNfe/public/CertificateImportation.vue'),
        meta: {
            title: 'Importação de Certificado',
        },
    },
    {
        path: '/validation-xml/upload/:token',
        type: 'public',
        component: () => import('@/views/Verify/public/ImportForLink.vue'),
        meta: {
            title: 'Importação Externa',
        },
    },

    {
        path: '/icms-exclusion',
        component: () => import('@/views/IcmsExclusion/IcmsExclusion.vue'),
        name: 'exclusao-icms-st',
        meta: {
            title: 'Exclusão de ICMS ST',
        },
        children: [
            {
                path: 'database-validation/list',
                component: () =>
                    import('@/views/IcmsExclusion/DatabaseValidationList.vue'),
                meta: {
                    title: 'Validações de Banco de Dados',
                },
            },
            {
                path: 'database-validation',
                component: () =>
                    import('@/views/IcmsExclusion/DatabaseValidation.vue'),
                meta: {
                    title: 'Validação de Banco de Dados',
                },
            },
            {
                path: 'import-sped/list',
                component: () =>
                    import('@/views/IcmsExclusion/SpedImportList.vue'),
                meta: {
                    title: 'Importações SPED',
                },
            },
            {
                path: 'import-sped',
                component: () => import('@/views/IcmsExclusion/ImportSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'extract-data',
                component: () =>
                    import('@/views/IcmsExclusion/ExtractData.vue'),
                meta: {
                    title: 'Extrair dados',
                },
            },
            {
                path: 'generate-calculations',
                component: () =>
                    import('@/views/IcmsExclusion/GenerateCalculus.vue'),
                meta: {
                    title: 'Gerar cálculos',
                },
            },
            {
                path: 'export-calculations',
                component: () =>
                    import('@/views/IcmsExclusion/ListCalculus.vue'),
                meta: {
                    title: 'Exportar cálculos',
                },
            },
        ],
    },

    {
        path: '/icms-exclusion/tour',
        component: () =>
            import('@/views/IcmsExclusion/Tour/IcmsExclusionTourLayout.vue'),
        name: 'exclusao-icms-st-tour',
        meta: {
            title: 'Tour: Exclusão de ICMS ST',
        },
        children: [
            {
                path: '',
                redirect: { name: 'icms-exclusion-tour-db-validation' },
            },
            {
                path: 'database-validation',
                name: 'icms-exclusion-tour-db-validation',
                component: () =>
                    import('@/views/IcmsExclusion/Tour/TourDatabaseValidation.vue'),
                meta: {
                    title: 'Tour: Validação de Banco de Dados',
                },
            },
            {
                path: 'import-sped',
                name: 'icms-exclusion-tour-import-sped',
                component: () =>
                    import('@/views/IcmsExclusion/Tour/TourImportSped.vue'),
                meta: {
                    title: 'Tour: Importar SPED',
                },
            },
            {
                path: 'extract-data/flow-1',
                name: 'icms-exclusion-tour-extract-flow-1',
                component: () =>
                    import('@/views/IcmsExclusion/Tour/TourExtractDataFlow1.vue'),
                meta: {
                    title: 'Tour: Extração Banco × Banco',
                },
            },
            {
                path: 'extract-data/flow-3',
                name: 'icms-exclusion-tour-extract-flow-3',
                component: () =>
                    import('@/views/IcmsExclusion/Tour/TourExtractDataFlow3.vue'),
                meta: {
                    title: 'Tour: Extração Banco × XML',
                },
            },
            {
                path: 'generate-calculations',
                name: 'icms-exclusion-tour-generate-calculations',
                component: () =>
                    import('@/views/IcmsExclusion/Tour/TourGenerateCalculus.vue'),
                meta: {
                    title: 'Tour: Gerar Apuração',
                },
            },
            {
                path: 'export-calculations',
                name: 'icms-exclusion-tour-export-calculations',
                component: () =>
                    import('@/views/IcmsExclusion/Tour/TourExportCalculus.vue'),
                meta: {
                    title: 'Tour: Exportar cálculos',
                },
            },
        ],
    },

    {
        path: '/reforma-tributaria',
        component: () =>
            import('@/views/ReformaTributaria/ReformaTributaria.vue'),
        name: 'reforma-tributaria',
        meta: {
            title: 'Diagnóstico da Reforma Tributária',
        },
        children: [
            {
                path: 'clientes',
                component: () =>
                    import('@/views/ReformaTributaria/clientes/ClientesGate.vue'),
                meta: {
                    title: 'Selecionar cliente',
                },
            },
            {
                path: 'diagnosticos',
                component: () =>
                    import('@/views/ReformaTributaria/diagnostico/DiagnosticosList.vue'),
                meta: {
                    title: 'Diagnósticos',
                },
            },
            {
                path: 'diagnosticos/novo',
                component: () =>
                    import('@/views/ReformaTributaria/diagnostico/DiagnosticoForm.vue'),
                meta: {
                    title: 'Novo diagnóstico',
                },
            },
            {
                path: 'importar-sped',
                component: () =>
                    import('@/views/ReformaTributaria/sped/ImportarSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'revisar-cfop',
                component: () =>
                    import('@/views/ReformaTributaria/cfop/RevisarCfop.vue'),
                meta: {
                    title: 'Revisar CFOP',
                },
            },
            {
                path: 'importar-movimentos',
                component: () =>
                    import('@/views/ReformaTributaria/movimentos/ImportarMovimentos.vue'),
                meta: {
                    title: 'Importar movimentos',
                },
            },
            {
                path: 'importar-documentos-contabeis',
                redirect: '/reforma-tributaria/diagnosticos',
            },
            {
                path: 'diagnosticos/:id/premissas',
                component: () =>
                    import('@/views/ReformaTributaria/diagnostico/DiagnosticoForm.vue'),
                meta: {
                    title: 'Premissas e filiais',
                },
            },
            {
                path: 'diagnosticos/:id/importar-sped',
                component: () =>
                    import('@/views/ReformaTributaria/sped/ImportarSped.vue'),
                meta: {
                    title: 'Importar SPED',
                },
            },
            {
                path: 'diagnosticos/:id/revisar-cfop',
                component: () =>
                    import('@/views/ReformaTributaria/cfop/RevisarCfop.vue'),
                meta: {
                    title: 'Revisar CFOP',
                },
            },
            {
                path: 'diagnosticos/:id/importar-movimentos',
                component: () =>
                    import('@/views/ReformaTributaria/movimentos/ImportarMovimentos.vue'),
                meta: {
                    title: 'Importar movimentos',
                },
            },
            {
                path: 'revisar-promover-movimentos',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/revisao/RevisarPromoverMovimentos.vue'
                    ),
                meta: {
                    title: 'Revisar e promover movimentos',
                },
            },
            {
                path: 'diagnosticos/:id/revisar-promover-movimentos',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/revisao/RevisarPromoverMovimentos.vue'
                    ),
                meta: {
                    title: 'Revisar e promover movimentos',
                },
            },
            {
                path: 'conciliar-fontes-creditaveis',
                redirect: '/reforma-tributaria/diagnosticos',
            },
            {
                path: 'diagnosticos/:id/conciliar-fontes-creditaveis',
                redirect: to =>
                    `/reforma-tributaria/diagnosticos/${to.params.id}/gerar-diagnostico`,
            },
            {
                path: 'geracoes-concluidas',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/geracao/GeracoesConcluidas.vue'
                    ),
                meta: {
                    title: 'Diagnósticos gerados',
                },
            },
            {
                path: 'gerar-diagnostico',
                component: () =>
                    import('@/views/ReformaTributaria/geracao/GerarDiagnostico.vue'),
                meta: {
                    title: 'Gerar diagnóstico',
                },
            },
            {
                path: 'diagnosticos/:id/gerar-diagnostico',
                component: () =>
                    import('@/views/ReformaTributaria/geracao/GerarDiagnostico.vue'),
                meta: {
                    title: 'Gerar diagnóstico',
                },
            },
            {
                path: 'resultado',
                redirect: '/reforma-tributaria/diagnosticos',
            },
            {
                path: 'diagnosticos/:id/resultado',
                redirect: to => `/reforma-tributaria/diagnosticos/${to.params.id}`,
            },
            {
                path: 'formacao-preco',
                redirect: '/reforma-tributaria/diagnosticos',
            },
            {
                path: 'diagnosticos/:id/formacao-preco',
                redirect: to => `/reforma-tributaria/diagnosticos/${to.params.id}`,
            },
            {
                path: 'fluxo-caixa',
                redirect: '/reforma-tributaria/diagnosticos',
            },
            {
                path: 'diagnosticos/:id/fluxo-caixa',
                redirect: to => `/reforma-tributaria/diagnosticos/${to.params.id}`,
            },
            {
                path: 'diagnosticos/:id/importar-documentos-contabeis',
                redirect: to =>
                    `/reforma-tributaria/diagnosticos/${to.params.id}/revisar-promover-movimentos`,
            },
            {
                path: 'diagnosticos/:id',
                component: () =>
                    import('@/views/ReformaTributaria/diagnostico/DiagnosticoHub.vue'),
                meta: {
                    title: 'Diagnóstico',
                },
            },
            {
                path: 'parametros/cfop',
                redirect: '/reforma-tributaria/revisar-cfop',
            },
            {
                path: 'parametros/cfop/novo',
                redirect: '/reforma-tributaria/revisar-cfop',
            },
            {
                path: 'parametros/cfop/:id',
                redirect: '/reforma-tributaria/revisar-cfop',
            },
            {
                path: 'parametros/reforma',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/parametros/ReformaList.vue'
                    ),
                meta: {
                    title: 'Parâmetros da reforma',
                    requiresAdmin: true,
                },
            },
            {
                path: 'parametros/reforma/novo',
                redirect: '/reforma-tributaria/parametros/reforma',
            },
            {
                path: String.raw`parametros/reforma/:id(\d+)`,
                redirect: '/reforma-tributaria/parametros/reforma',
            },
            {
                path: 'parametros/limite-simples',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/parametros/LimiteSimplesList.vue'
                    ),
                meta: {
                    title: 'Limite do Simples Nacional',
                    requiresAdmin: true,
                },
            },
            {
                path: 'parametros/limite-simples/novo',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/parametros/LimiteSimplesForm.vue'
                    ),
                meta: {
                    title: 'Adicionar limite do Simples',
                    requiresAdmin: true,
                },
            },
            {
                path: 'parametros/limite-simples/:id',
                component: () =>
                    import(
                        '@/views/ReformaTributaria/parametros/LimiteSimplesForm.vue'
                    ),
                meta: {
                    title: 'Editar limite do Simples',
                    requiresAdmin: true,
                },
            },
        ],
    },
    {
        path: '/not-found',
        component: () => import('@/views/NotFound.vue'),
        meta: {
            title: 'Não encontrado',
        },
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

const PROTECTED_ROUTE_NAMES = new Set([
    'xml-nfe',
    'food-basket',
    'icms-fine-diagnosis',
    'credito-pis-cofins',
    'subvencao',
    'simples-nacional',
    'verbas',
    'usuarios',
    'atualizacao-de-base',
    'consulta-ao-simples',
    'atualizacoes',
    'newatualizacoes',
    'exclusao-icms-st',
    'exclusao-icms-st-tour',
    'forms',
    'reforma-tributaria',
])

function resolveDocumentTitle(meta) {
    const raw = meta?.title
    return typeof raw === 'string' ? raw : ''
}

function hasValidSessionJwt(jwt) {
    return jwt?.iss === 'Controlsul' && jwt.exp > Date.now() / 1000
}

function resolveProtectedRouteToCheck(to) {
    if (PROTECTED_ROUTE_NAMES.has(to.name)) {
        return to.name
    }
    const parentRoute = to.matched.find(route =>
        PROTECTED_ROUTE_NAMES.has(route.name),
    )
    return parentRoute?.name ?? null
}

async function guardProtectedRoute(to, next) {
    const routeToCheck = resolveProtectedRouteToCheck(to)

    console.log('Rota a verificar:', routeToCheck) // DEBUG

    if (!routeToCheck) {
        next()
        return
    }

    const permission = await resolveUserPermission(routeToCheck)
    console.log('Resultado da verificação:', permission) // DEBUG

    if (!permission.ok) {
        console.log('Sem permissão, redirecionando para home') // DEBUG
        next({ path: '/' })
        return
    }

    const requiresAdmin = to.matched.some(route => route.meta?.requiresAdmin)
    if (requiresAdmin && permission.level !== 1) {
        next({ path: '/not-found' })
        return
    }

    next()
}

async function navigateAuthenticated(to, next) {
    if (to.path === '/login') {
        next({ path: '/' })
        return
    }

    await guardProtectedRoute(to, next)
}

function navigateUnauthenticated(to, next) {
    console.log('JWT inválido, redirecionando para login') // DEBUG
    if (to.path.includes('/reset-password')) next()
    if (to.path.startsWith('/certificates/upload')) next()
    if (to.path.startsWith('/validation-xml/upload')) next()
    if (to.path !== '/login') {
        next({ path: '/login' })
        return
    }
    next()
}

const resolveUserPermission = async routeName => {
    try {
        const jwt = Auth()
        console.log('JWT:', jwt) // DEBUG

        if (jwt?.iss !== 'Controlsul' || jwt.exp <= Date.now() / 1000) {
            console.log('JWT inválido ou expirado') // DEBUG
            return { ok: false, level: null }
        }

        console.log('Verificando permissão para rota:', routeName) // DEBUG

        const response = await http.get(
            `${globalThis.URL_API_NODEJS}/user/permission/${jwt.id}`,
        )

        console.log('Resposta da API:', response.data) // DEBUG

        const permissions = response.data.permissions

        if (!response.data.active) {
            console.log('Usuário inativo') // DEBUG
            localStorage.removeItem('tk_3000')
            globalThis.location.href = '/login'
            return { ok: false, level: null }
        }

        const match = permissions.find(
            permission =>
                permission.route === routeName ||
                (routeName === 'exclusao-icms-st-tour' &&
                    permission.route === 'exclusao-icms-st'),
        )
        console.log('Tem permissão:', Boolean(match), 'para rota:', routeName) // DEBUG

        return { ok: Boolean(match), level: match?.level ?? null }
    } catch (error) {
        console.error('Erro ao verificar permissões:', error)
        return { ok: false, level: null }
    }
}

router.beforeEach(async (to, from, next) => {
    document.title = `Controlsul - ${resolveDocumentTitle(to.meta)}`
    const jwt = Auth()

    console.log('Navegando para:', to.name, to.path) // DEBUG

    if (hasValidSessionJwt(jwt)) {
        await navigateAuthenticated(to, next)
        return
    }

    navigateUnauthenticated(to, next)
})

export default router
